<template>
  <ul class="list-unstyled list-inline gallery">
    <li v-for="(image, index) in limitedImages" :key="index" class="list-inline-item">
      <ArtworkImage :image="image" version="400" v-if="image" />
    </li>
  </ul>
</template>
<script>
import ArtworkImage from './ArtworkImage.vue';
import Artwork from 'api/artwork.js';

export default {
  name: 'MovementArtworksImages',
  props: {
    movement: Object,
  },
  mounted() {
    this.fetchImages();
  },
  updated() {
    this.$nextTick(() => {
      this.$parent.$emit('imagesLoad');
    });
  },
  components: {
    ArtworkImage,
  },
  computed: {
    limitedImages() {
      return this.images;
    },
  },
  methods: {
    fetchImages: async function () {
      this.images = await Artwork.movementArtworks(this.movement._id);
    },
  },
  watch: {
    movement: function (newMovement, oldMovement) {
      this.images = [];
      this.fetchImages();
    },
  },
  data() {
    return {
      images: [],
    };
  },
};
</script>
